import { telemetry } from '../../../@vendor/Posthog';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { PopupManager } from '../../popups/PopupManager';
import { BoardInfo } from '../BoardInfo';
import { EditorSession } from '../EditorSession';
import { replayPopup } from './ReplayPopup';

const invokeTimeMachinePopupAtRootScope = defineCommand(
    'invokeTimeMachinePopupAtRootScope',
    null,
    (r, [boardId, elmtId]: [string, string?]) => {
        r.call(PopupManager).invoke(replayPopup(boardId, elmtId));
    },
);

export const timeMachine = defineCommand(
    'timeMachine',
    'Time Machine',
    (r, [elmtId]: [string?]) => {
        telemetry.emit('interaction.replay');
        const { id: boardId } = r.call(EditorSession).get(BoardInfo);
        r.call(CommandDispatcher).root(invokeTimeMachinePopupAtRootScope, [boardId, elmtId]);
    },
);
